<div class="bg-base-100">
<div class="hero w-full h-70 flex-row justify-items-start"
  style="background-image: url('images/aboutPage/theater-chair.png');">
  <div class="hero-overlay bg-neutral-800  opacity-80"></div>
  <div class="hero-content px-10">
      <h1 class="w-full font-heading text-balance bg-gradient-to-r from-primary  to-accent bg-clip-text text-transparent basis-300 font-medium text-[40px] text-left">Contact Us</h1>
  </div>
  </div>
  <div class="p-10 text-neutral bg-base-200 mx-6 my-10 rounded-2xl ">
    <div class="grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-2" >
        <div class="flex flex-col items-start text-neutral">
            <h2 class="text-[30px]  my-3 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent font-bold">Information</h2>
            <div class="w-98 my-5 text-[20px]">
                <p class="my-2">We'd love to hear from you! Whether you have a question, feedback, or just want to say hello feel free to reach out.You can contact us using the form below, or reach us directly at</p>
                   <a class="my-1 block hover:text-primary" href="">
                    <ng-icon name="faSolidEnvelope" size="15px"/>
                    iti &#64;support.com</a>
                  <a class="my-1 block hover:text-primary" href="">
                     <ng-icon name="faSolidPhone" size="15px"/>
                    +20 258-456-7890</a>
            </div>
            <div class="text-primary flex gap-2 my-5  p-2">
              <div class=" bg-primary  border-2  border-primary text-base-200 p-2 rounded-box transition-all duration-200 ease-in-out hover:border-primary hover:bg-base-200 hover:text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"></path>
                </svg>
              </div>

              <div class=" bg-primary  border-2  border-primary text-base-200 p-2 rounded-box transition-all duration-200 ease-in-out hover:border-primary hover:bg-base-200 hover:text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="fill-current"><path d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"></path>
                </svg>
              </div>

              <div class=" bg-primary  border-2  border-primary text-base-200 p-2 rounded-box transition-all duration-200 ease-in-out hover:border-primary hover:bg-base-200 hover:text-primary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24"height="24"viewBox="0 0 24 24" class="fill-current"><path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"></path>
                </svg>
              </div>
            </div>

        </div>

        <div class=" bg-base-300  flex flex-col items-start  border-t-4 border-t-primary p-5 rounded-lg shadow-md  space-y-4">
          <form class="form w-full space-y-4">

            <div class="flex items-center gap-2 w-full bg-base-100 text-primary border-2 rounded-2xl border-base-300 focus-within:border-primary px-3 py-2 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 opacity-50" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M17.982 18.725A7.488 7.488 0 0 0 12 15.75a7.488 7.488 0 0 0-5.982 2.975m11.963 0a9 9 0 1 0-11.963 0A8.966 8.966 0 0 1 12 21a8.966 8.966 0 0 1-5.982-2.275M15 9.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
              </svg>
              <input
                type="text"
                class="grow bg-transparent outline-none border-none focus:outline-none"
                placeholder="Username"
              />
            </div>

            <div class="flex items-center gap-2 w-full bg-base-100  text-primary border-2 rounded-2xl border-base-300 focus-within:border-primary  px-3 py-2 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 opacity-50" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25" />
              </svg>
              <input type="email" class="grow bg-transparent outline-none border-none focus:outline-none" placeholder="Email" />
            </div>

            <div class="flex items-center gap-2 w-full bg-base-100  text-primary border-2 rounded-2xl border-base-300 focus-within:border-primary  px-3 py-2 transition-colors">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 opacity-50" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l7.5 4.5 7.5-4.5m-15-4.5l7.5 4.5 7.5-4.5" />
              </svg>
              <input type="text" class="grow bg-transparent outline-none border-none focus:outline-none" placeholder="Content" />
            </div>

            <div class="flex items-center gap-2 w-full bg-base-100  text-primary border-2 rounded-2xl border-base-300 focus-within:border-primary px-3 py-2 transition-colors">
              <textarea class="bg-transparent resize-none focus:outline-none w-full h-32 text-primary
              " placeholder="Write your message..."></textarea>
            </div>

            <button type="submit" class=" text-base-200 btn btn-primary w-50 transition-all duration-200 ease-in-out hover:outline-primary hover:bg-base-200 hover:text-primary">
              Send Message
            </button>
          </form>

        </div>
    </div>
  </div>
  <div class="p-10 text-neutral bg-base-200 mx-6 my-10 rounded-2xl ">
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <!-- left-->
      <div class="flex flex-col items-start">
        <p class="mb-5 text-base-300 font-bold text-[20px] flex items-end gap-2">
          Our story
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6 text-primary">
            <path stroke-linecap="round" stroke-linejoin="round" d="m11.99 16.5 3.75 3.75m0 0 3.75-3.75m-3.75 3.75V3.75H4.49" />
          </svg>
        </p>

        <div class="flex w-full">
          <div class="w-[8px] bg-gradient-to-b from-secondary to-accent rounded-l"></div>
          <div class="bg-neutral pl-4 pb-2 w-full">
            <p class="text-base-100 text-[30px]">
              Your Vision Our Expertise Your Success<br />
              Get Noticed Generated
            </p>
            <p class="text-accent text-[30px] font-bold">Leads Dominate.</p>
          </div>
        </div>

        <div class="w-full mt-5">
          <img src="images/contactPage/hero.png" class="rounded-3xl shadow-sm shadow-secondary" alt="notFound" />
        </div>
      </div>

      <!-- right -->
      <div class="flex flex-col w-full">
        <div class=" mt-5 grid lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-2 gap-4">
          <div class="relative text-[15px]">
            <img src="images/contactPage/1.png" class="rounded-3xl shadow-sm shadow-accent" alt="notFound" />
            <span class="absolute top-3 left-3 text-base-200 border-1 border-accent bg-accent rounded-2xl px-2 hover:border-base-200 hover:text-accent hover:bg-base-200">Trends</span>
            <span class="absolute top-3 right-3 text-base-200 border-1 border-accent bg-accent rounded-2xl px-2 hover:border-base-200 hover:text-accent hover:bg-base-200">Top Tech</span>
          </div>
          <div class="relative text-[15px]">
            <img src="images/contactPage/2.png" class="rounded-3xl shadow-sm shadow-accent" alt="notFound" />
            <span class="absolute top-3 left-3 text-base-200 border-1 border-accent bg-accent rounded-2xl px-2 hover:border-base-200 hover:text-accent hover:bg-base-200">Trends</span>
            <span class="absolute top-3 right-3 text-base-200 border-1 border-accent bg-accent rounded-2xl px-2 hover:border-base-200 hover:text-accent hover:bg-base-200">Top Tech</span>
          </div>
        </div>
        <div class="text-[18px] my-10 px-5 text-neutral" >
              <p>
                At BlockBuster, trust is the foundation of everything we do. We are committed to providing a secure, transparent, and reliable movie experience for every user. From carefully curated content to safe and seamless browsing, we ensure our community always feels confident and respected. With a growing base of satisfied users, we’re proud to be a trusted name in the world of online cinema.</p>
        </div>
        <div class="stats stats-vertical md:stats-horizontal shadow-lg bg-base-200">
          <div class="stat">
            <div class="stat-figure text-primary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                class="inline-block h-8 w-8 stroke-current hover:stroke-accent">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"></path>
              </svg>
            </div>
            <div class="stat-title  text-accent">Total Likes</div>
            <div class="stat-value text-primary">25.6K</div>
            <div class="stat-desc  text-base-300">21% more than last month</div>
          </div>

          <div class="stat">
            <div class="stat-figure text-secondary">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                class="inline-block h-8 w-8 stroke-current hover:stroke-accent">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"></path>
              </svg>
            </div>
            <div class="stat-title text-accent ">Page Views</div>
            <div class="stat-value text-secondary">2.6M</div>
            <div class="stat-desc  text-base-300">21% more than last month</div>
          </div>


        </div>
      </div>
    </div>
  </div>
</div>
